<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Product Group Name"
                  v-model="productGroup.name"
                  type="text"
                  :rules="rules.productGroupNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Product Group Code"
                  v-model="productGroup.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Product Group Description"
                  v-model="productGroup.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="productGroup.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="productGroup.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="productGroup.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="productGroup.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="productGroup.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="productGroup.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="productGroup.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { productGroupService } from "../../services/product-group-service";
import { ProductGroup } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { ProductGroupFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";

export default {
  name: "ProductGroupDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Product Group",
        disabled: false,
        to: "product-groups"
      },
      {
        text: "Product Group Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    productGroup: new ProductGroup(),
    oldProductGroup: new ProductGroup(),
    statusFlag: true,
    saveLoading: false,
    responseError: "",
    rules: new ProductGroupFormRules()
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new productGroup
    } else {
      this.getProductGroupDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.productGroup.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        let productGroupObj = {
          id: this.productGroup.id ? this.productGroup.id : "",
          name: this.productGroup.name,
          code: this.productGroup.code,
          description: this.productGroup.description,
          status: this.productGroup.status
        };
        productGroupService
          .saveProductGroup(productGroupObj)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getProductGroupDetail(id) {
      productGroupService
        .getProductGroupDetail(id)
        .then(res => {
          this.productGroup = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.productGroup.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.productGroup.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldProductGroup = Object.assign({}, res.data);
          this.statusFlag = this.productGroup.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.productGroup.id) {
        this.productGroup = new ProductGroup();
        this.statusFlag = true;
      } else {
        this.productGroup = Object.assign({}, this.oldProductGroup);
        this.statusFlag = this.productGroup.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/product-groups");
    }
  }
};
</script>

